import { type KeyboardEvent, type MouseEvent, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import loadable from '@loadable/component';

import { Link, LinkVariant, RenderType } from '@jsmdg/yoshi';
import { trackRedeemInfoClicked } from './RedeemInfo.tracking';

const LoadableRedeemInfoModal = loadable(async () => import('../RedeemInfoModal/RedeemInfoModal'));

const messages = defineMessages({
    redeemInfo: {
        defaultMessage: 'flexibel einlösbar',
    },
    capitalizedRedeemInfo: {
        defaultMessage: 'Flexibel einlösbar',
    },
    a11yLinkText: {
        defaultMessage: 'Link Info über Flexibel einlösbar',
    },
});

type RedeemInfoProps = {
    readonly isInline?: boolean;
};

const RedeemInfo = ({ isInline = false }: RedeemInfoProps): JSX.Element => {
    const intl = useIntl();
    const [showModal, setShowModal] = useState(false);
    const redeemInfoMessage = isInline ? messages.redeemInfo : messages.capitalizedRedeemInfo;

    const handleOpenOrClosePopup = (
        event: MouseEvent | KeyboardEvent | undefined,
        shouldShowModal: boolean,
    ) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        setShowModal(shouldShowModal);
    };

    const handleRedeemInfoClick = (event: MouseEvent): void => {
        handleOpenOrClosePopup(event, true);
        void trackRedeemInfoClicked();
    };

    return (
        <>
            <Link
                onClick={handleRedeemInfoClick}
                variant={LinkVariant.Grey}
                as={RenderType.Button}
                className="d-inline-block mb-0-5x"
                aria-label={intl.formatMessage(messages.a11yLinkText)}
            >
                {intl.formatMessage(redeemInfoMessage)}
            </Link>
            {showModal && (
                <LoadableRedeemInfoModal
                    isOpen={showModal}
                    handleOnClose={(event?: MouseEvent | KeyboardEvent) =>
                        handleOpenOrClosePopup(event, false)
                    }
                />
            )}
        </>
    );
};

export { RedeemInfo };
